import { DataSource } from "@mcleod/components";
import { CityUtil } from "@mcleod/core";
import { PortalCustomerSettings } from "@mcleod/portal-customer";
import { LtlQuote } from "./LtlQuote";
import { AutogenLayoutCarrierSelectionOverview } from "./autogen/AutogenLayoutCarrierSelectionOverview";

export class CarrierSelectionOverview extends AutogenLayoutCarrierSelectionOverview {
    private _ltlQuote: LtlQuote;

    public get ltlQuote(): LtlQuote {
        return this._ltlQuote;
    }

    public set ltlQuote(value: LtlQuote) {
        if (this._ltlQuote == null) {
            this._ltlQuote = value;
            this.setupStopsPanel(this.ltlQuote.sourceQuoteStops);
        }
    }

    override onLoad() {
        this.labelWelcomeMsg.text = PortalCustomerSettings.get().order_welcome_message;
    }

    setupStopsPanel(sourceQuoteStops: DataSource) {
        const shipperRow = sourceQuoteStops.data[0];
        this.labelPickupAddress.text = shipperRow.get("location_name");
        this.labelPickupAddress.text = shipperRow.get("address1");
        this.labelPickupCityState.text = CityUtil.formatCityStateZip(shipperRow.get("city_name"), shipperRow.get("state_id"), shipperRow.get("zip_code"))

        //   labelPickupAddress: Label;
        // labelPickupCityState: Label;
        // labelPickupDelivery: Label;
        // labelPickupName: Label;
        const consigneeRow = sourceQuoteStops.data[1];
    }
}
